import { Info } from 'lucide-react'
import { useState } from 'react'
import { PopoverSheet } from '@/components/ui/PopoverSheet'
import { StatusPill } from '@/components/ui/StatusPill'
import { InvoiceStatusPill } from '@/components/invoices/InvoiceStatusPill'
import { ATTENTION_COPY, STATUS_COPY } from '@/lib/invoice-status-copy'
import type { InvoiceStatus } from '@/lib/invoice-types'

/**
 * De plek om het onderscheid op te zoeken als je het actiemenu niet open hebt
 * staan. REPLACED staat er niet bij: die ontstaat alleen nog uit de import.
 */
const ORDER: InvoiceStatus[] = [
  'DRAFT',
  'PARKED',
  'PENDING_APPROVAL',
  'APPROVED',
  'SENT',
  'ESCALATED',
  'PAID',
  'WITHDRAWN',
  'WRITTEN_OFF',
  'VOIDED',
]

export function StatusLegend() {
  const [open, setOpen] = useState(false)

  return (
    <PopoverSheet
      open={open}
      onOpenChange={setOpen}
      title="Wat betekenen de statussen?"
      align="end"
      className="w-96 max-h-[70vh]"
      trigger={
        <button type="button" className="btn-ghost h-9 w-9 p-0 text-ink-faint" aria-label="Wat betekenen de statussen?">
          <Info className="h-4 w-4" />
        </button>
      }
    >
      <div className="min-h-0 flex-1 overflow-y-auto p-4">
        <p className="label-caps text-ink-faint">Wanneer welke status</p>
        <ul className="mt-3 space-y-3">
          {ORDER.map((status) => (
            <li key={status} className="flex flex-col gap-1">
              <InvoiceStatusPill status={status} className="self-start" />
              <p className="text-xs leading-relaxed text-ink-soft">{STATUS_COPY[status].what}</p>
            </li>
          ))}
          <li className="flex flex-col gap-1 border-t border-hairline pt-3">
            <StatusPill status="overdue" className="self-start" />
            <p className="text-xs leading-relaxed text-ink-soft">{ATTENTION_COPY}</p>
          </li>
        </ul>
      </div>
    </PopoverSheet>
  )
}
